import {
  QueryKey,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';
import { ReactNode } from 'react';

interface SuspenseQueryContentProps<
  TQueryFnData,
  TError,
  TData,
  TQueryKey extends QueryKey,
> {
  children: (queryResult: UseSuspenseQueryResult<TData, TError>) => ReactNode;
  options: UseSuspenseQueryOptions<TQueryFnData, TError, TData, TQueryKey>;
}

const SuspenseQueryContent = <
  TQueryFnData,
  TError,
  TData,
  TQueryKey extends QueryKey,
>({
  children,
  options,
}: SuspenseQueryContentProps<TQueryFnData, TError, TData, TQueryKey>) => {
  const queryResult = useSuspenseQuery(options);

  return children(queryResult);
};

export default SuspenseQueryContent;
